// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kecleon: PokeData = {
  "id": 352,
  "name": "kecleon",
  "height": 10,
  "weight": 220,
  "base_experience": 154,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "scratch",
    "bind",
    "tail-whip",
    "disable",
    "psybeam",
    "screech",
    "lick",
    "fury-swipes",
    "slash",
    "substitute",
    "thief",
    "feint-attack",
    "detect",
    "ancient-power",
    "camouflage",
    "astonish",
    "feint",
    "sucker-punch",
    "shadow-claw",
    "shadow-sneak",
    "synchronoise",
    "foul-play"
  ],
  "moves": [
    "scratch",
    "lick",
    "ancient-power",
    "shadow-sneak",
    "supersonic",
    "protect",
    "headbutt",
    "body-slam",
    "quick-attack",
    "tackle",
    "refresh",
    "growl",
    "scary-face"
  ],
  "evolution_chain": {
    "id": 180,
    "item": null,
    "species": [
      {
        "name": "kecleon",
        "order": 380,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 149,
    "speed": 77,
    "ability_power": 173
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
